import { useEffect, useRef, useState } from "react";
import { displayName } from "../lib/anagConfig";
import useCompagniaMatcher from "../lib/useCompagniaMatcher";
import { Input } from "./ui/input";
import { Pencil } from "lucide-react";

// Campo professionista: testo libero con suggerimenti dall'anagrafica + pulsante modifica.
export default function ProField({ items = [], value, onChange, onCommit, compagnia, testId, onEdit, label }) {
  const [open, setOpen] = useState(false);
  const { inCompagnia } = useCompagniaMatcher(!!compagnia);
  const boxRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const matched = compagnia
    ? items.filter((i) => inCompagnia(i.compagnie, compagnia))
    : items;
  const noneForCompagnia = !!(compagnia && matched.length === 0);
  const base = matched;
  const q = (value || "").toLowerCase().trim();
  const sugg = (q ? base.filter((i) => displayName(i).toLowerCase().includes(q)) : base).slice(0, 12);

  return (
    <div className="mt-1.5 flex items-center gap-1.5">
      <div className="relative flex-1" ref={boxRef}>
        <Input
          value={value || ""}
          onChange={(e) => { onChange(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onBlur={() => onCommit?.(value)}
          placeholder="Digita o seleziona…"
          data-testid={testId}
          autoComplete="off"
          className="bg-slate-900/60 border-slate-700"
        />
        {open && (sugg.length > 0 || noneForCompagnia) && (
          <div className="absolute z-50 mt-1 w-full max-h-52 overflow-y-auto rounded-lg border border-slate-700 bg-[#0d111a] shadow-xl" data-testid={`${testId}-list`}>
            {noneForCompagnia && (
              <div className="px-3 py-2 text-[11px] font-semibold text-amber-400 bg-amber-500/10" data-testid={`${testId}-nofilter`}>
                Nessun {label || "soggetto"} associato a {compagnia}
              </div>
            )}
            {sugg.map((r) => (
              <button type="button" key={r.id} onMouseDown={(e) => { e.preventDefault(); onChange(displayName(r)); onCommit?.(displayName(r)); setOpen(false); }}
                className="w-full text-left px-3 py-2 text-sm text-slate-200 hover:bg-slate-800/70">
                {displayName(r)}
              </button>
            ))}
          </div>
        )}
      </div>
      <button type="button" onClick={() => onEdit?.()} data-testid={`${testId}-edit`} title="Modifica in anagrafica"
        className="shrink-0 h-9 w-9 flex items-center justify-center rounded-md border border-slate-700 bg-slate-800/60 text-slate-100 hover:text-amber-400 hover:border-amber-500/40 hover:bg-slate-700/60 transition-colors">
        <Pencil className="h-4 w-4" />
      </button>
    </div>
  );
}
